import { render, staticRenderFns } from "./EditLabel.vue?vue&type=template&id=163152ea&scoped=true&"
import script from "./EditLabel.vue?vue&type=script&lang=ts&"
export * from "./EditLabel.vue?vue&type=script&lang=ts&"
import style0 from "./EditLabel.vue?vue&type=style&index=0&id=163152ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163152ea",
  null
  
)

export default component.exports